// Syntax colors for docs code blocks: <pre class="code-block"><code class="language-json">.
// Only the languages the docs use are registered, to keep the pack small.
// Colors live with .code-block in tokens.css.
import hljs from "highlight.js/lib/core";
import bash from "highlight.js/lib/languages/bash";
import json from "highlight.js/lib/languages/json";
import python from "highlight.js/lib/languages/python";
import xml from "highlight.js/lib/languages/xml";

// The LSC URIs: scheme, host, query names and the placeholders to fill in,
// with optional [parts] and the mapping diagram's lines dimmed.
const uri = () => ({
  name: "URI",
  contains: [
    { scope: "scheme", match: /[a-z][a-z0-9+.-]*(?=:\/\/)/ },
    { match: [/:\/\//, /[^\s/?:[\]]+/], scope: { 1: "punctuation", 2: "host" } },
    { scope: "optional", match: /\[[^\]\n]*\]/ },
    { scope: "placeholder", match: /<[^>\n]+>|\b[A-Z][A-Z_]*[A-Z]\b/ },
    { scope: "param", match: /\b[a-z][a-z0-9_]*(?==)/ },
    { scope: "punctuation", match: /[?&=]|[│└─]+/ }
  ]
});

hljs.registerLanguage("bash", bash);
hljs.registerLanguage("json", json);
hljs.registerLanguage("python", python);
hljs.registerLanguage("xml", xml);
hljs.registerLanguage("uri", uri);

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll('pre.code-block code[class*="language-"]')
    .forEach((el) => hljs.highlightElement(el));
});
